import type { JSX } from "react";
import { useState } from "react";

import ArrowRight from "@repo/icons/default/ArrowRight";

import { CertificateProceduresFooter } from "@/components/flows/steps/council/components/certificate-procedures-footer";
import { Button } from "@/components/ui/button/button";
import { FileUploadCard } from "@/components/ui/file-upload-card/file-upload-card";

interface CertificateProceduresSubStepProps {
  professionDescription: string;
  onSubmit: (fileUrl: string | null) => void;
  isLoading?: boolean;
  buttonText?: string;
}

const ProcedureCertificateFileType = 5;

export const CertificateProceduresSubStep = ({
  professionDescription,
  onSubmit,
  isLoading,
  buttonText = "Continuar",
}: CertificateProceduresSubStepProps): JSX.Element => {
  const [fileId, setFileId] = useState<string | null>(null);

  return (
    <div className="flex flex-col gap-6 h-full justify-between pb-6">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-1">
          <h2 className="text-xl font-bold text-neutral-900">
            Anexe o seu documento complementar para realização de procedimentos
          </h2>
          <p className="text-sm text-neutral-600">{professionDescription}</p>
        </div>

        <FileUploadCard
          codTipoArquivo={ProcedureCertificateFileType}
          onUploadFile={setFileId}
          allowPdf
        />
      </div>

      <div className="flex flex-col gap-3 sticky bottom-0 bg-white w-full">
        <Button
          loading={isLoading}
          fullWidth
          onClick={() => onSubmit(fileId)}
          disabled={!fileId}
        >
          <div className="flex flex-row gap-2 items-center">
            {buttonText}
            <ArrowRight size={24} />
          </div>
        </Button>
        <CertificateProceduresFooter />
      </div>
    </div>
  );
};
